export default __webpack_public_path__ + "static/media/foto2.6d8af343.JPG";